const temboUsersPage = {
  en: {
    temboUsers: {
      title: 'Tembo users',
      createBtn: 'Create new tembo user',
      editBtn: 'Edit',
      unblockBtn: 'Unblock',
      activeTab: 'Active ({msg})',
      blockedTab: 'Blocked ({msg})',
      statusChanged: 'Status has been successfully changed',
      statusNotChanged: 'Status has not been successfully changed',
      searchPlaceholder: 'Start typing name...',
      tableHeaderUsers: 'Users',
      tableHeaderEmail: 'Email',
      noSearchResult: 'No results for "{msg}"',
      clearSearchBtn: 'Clear results',
      noBlockedUsersTitle: 'No blocked users',
      noBlockedUsersText:
        'Blocked Tembo users doesn’t have access to tembo panel. You can block and unblock user at any time',
    },
    createTemboUser: {
      title: 'Create new tembo user',
      breadcrumbTemboUsers: 'Tembo users',
      breadcrumbCreate: 'Create new tembo user',
      cancelBtn: 'Cancel',
      createBtn: 'Done',
      selectTypesError: 'Please, select visit types',
      clinicianUpdatedNotification: 'Clinician has been successfully updated',
      chooseRoleError: 'You should choose a role',
      newUserUpdatedNotification: 'A new user has been successfully updated',
      leavePopupTitle: 'Are you sure you want to leave this page?',
      leavePopupText: 'Data will not to be saved',
    },
    editTemboUser: {
      title: 'Edit tembo user',
      breadcrumbTemboUsers: 'Tembo users',
      breadcrumbEdit: 'Edit tembo user',
      cancelBtn: 'Cancel',
      createBtn: 'Done',
      leavePopupTitle: 'Are you sure you want to leave this page?',
      leavePopupText: 'Data will not to be saved',
      fetchClinicianError: 'Something went wrong in getting clinician data. Please, try again later.',
      selectTypesError: 'Please, select visit types',
      clinicianUpdatedNotification: 'Clinician has been successfully updated',
      chooseRoleError: 'You should choose a role',
      newUserUpdatedNotification: 'User has been successfully updated',
    },
    temboUser: {
      breadcrumbTemboUsers: 'Tembo users',
      temboUserTag: 'Tembo user',
      clinicianTag: 'Clinician',
      blockedTag: 'Blocked',
      temboUserInfo: 'Tembo user information:',
      email: 'Email',
      phoneNumber: 'Phone number',
      clinicianInfo: 'Clinician information:',
      additionalPhone: 'Additional phone',
      visitTypes: 'Visit types',
      viewVisitHistory: 'View visit history',
      actionsTitle: 'Available actions:',
      actionEdit: 'Edit profile',
      actionResetPassword: 'Reset password',
      actionBlockUser: 'Block user',
      actionUnblockUser: 'Unblock user',
      actionDelete: 'Delete',
      statusChangedNotification: 'Status has been successfully changed',
      resetPasswordPopupTitle: 'Are you sure you want to reset password for {msg}?',
      resetPasswordPopupText:
        "This will immediately reset the user's password and send them an email with their new password. Continue?",
      resetPasswordNotification: 'Password reset link was sent to {msg}’s email.',
      deletePopupTitle: 'Are you sure you want to delete {msg}?',
      deletePopupText:
        "You won't be able to recover this user or do any actions. This user will no longer be discoverable in the user panel.",
      deleteNotification: '{msg} has been successfully deleted.',
    },
    temboUserForm: {
      mainInfoCardTitle: 'Main information',
      firstNameField: 'First name',
      lastNameField: 'Last name',
      primaryLicense: 'Primary license',
      emailField: 'Email',
      phoneNumberField: 'Phone number',
      rolesCardTitle: 'Roles',
      selectRoleTitle: 'Select role(s) for this user:',
      validation: {
        required: 'This field is required',
        email: 'Incorrect email',
      },
    },
    clinicianForm: {
      additionalInfoCardTitle: 'Additional information',
      preferredNameField: 'Preferred name',
      phoneNumberAdditionalField: 'Phone number (additional)',
      selectTypeTitle: 'Select what type of visits you can perform:',
    },
  },
}

export default temboUsersPage
